import jss from 'jss'
import preset from 'jss-preset-default'
class WidgetECFQuote extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            // Tạo variables class cần DOM trong widget
            selectors: {
                app: '#ecf-quote',
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );
        return {
            // Tạo variables DOM trong widget
            $app: this.$element.find( selectors.app ),
        };
    }

    initStyle(obj_img, responsive, img){
        let {top,left,right,bottom} = obj_img
        jss.setup(preset())
        const styles = {
            img:{
                position: 'absolute'
            }
        }

        if(typeof top != 'undefined') {
            styles['img']['top'] = top;
        }
        if(typeof left != 'undefined') {
            styles['img']['left'] = left;
        }
        if(typeof right != 'undefined') {
            styles['img']['right'] = right;
        }
        if(typeof bottom != 'undefined') {
            styles['img']['bottom'] = bottom;
        }

        if(responsive) {
            responsive = JSON.parse(responsive);
            responsive.forEach(function(item) {
                let img_css = {};
                let {top,left,right,bottom,width,display} = item;

                if(typeof top != 'undefined') img_css['top'] = top;
                if(typeof left != 'undefined') img_css['left'] = left;
                if(typeof right != 'undefined') img_css['right'] = right;
                if(typeof bottom != 'undefined') img_css['bottom'] = bottom;
                if(typeof width != 'undefined') img_css['width'] = width + 'px';
                if(typeof display != 'undefined') img_css['display'] = display;

                styles[`@media (max-width: ${item.breakpoint}px)`] = {
                    img : img_css
                };
            })
        }

        const {classes} = jss.createStyleSheet(styles).attach()
        img.classList.add(classes.img)
    }

    bindEvents() {
        const THIS = this;
        const ELEMENT = this.elements.$app[0];
        if(ELEMENT) {
            let imgs = Array.prototype.slice.call(ELEMENT.querySelectorAll('picture img'));
            imgs.forEach(element => {
                let dataPosition = element.getAttribute('data-position');
                let dataResponsive = element.getAttribute('data-responsive');
                let obj_img = JSON.parse(atob(dataPosition))
                let responsive = JSON.parse(atob(dataResponsive))
                THIS.initStyle(obj_img, responsive, element);
            });
        }
    }
}

jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetECFQuote, {
            $element,
        } );
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_quote.default', addHandler );
} );

